// @flow

import React from "react";
import { Flex, Avatar, Text } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { getUser } from "src/reducers";
import * as styles from "../styles";

import type { UID } from "src/types";

type Props = {
  id: UID
};

const CurvedUserLabel = ({ id }: Props) => {
  const user = useSelector(({ app }) => getUser(app, id));
  const { displayName, photoUrl, email } = user;

  return (
    <Flex>
      <Avatar
        sx={styles.UserAvatar}
        size="sm"
        name={displayName}
        src={photoUrl}
      />
      <Flex sx={styles.FlexColumn}>
        <Text isTruncated sx={styles.DisplayName}>
          {displayName}
        </Text>
        <Text isTruncated sx={styles.LightGreyText}>
          {email}
        </Text>
      </Flex>
    </Flex>
  );
};

export default CurvedUserLabel;
